import VerticalRegistry from "../../../constants/verticalRegistry";
import { resetSearchFields } from "../utils/searchFields";

const useHomeForm = (
  { values, handleChange, setFieldValue },
  setSelectedBranch,
) => {

  const searchConfig =
    VerticalRegistry.getVerticalByName(values.vertical)?.searchConfig ?? {};

  const activeCard = values.vertical
    ? (Object.keys(searchConfig).find((key) => searchConfig[key] === true) ??
      null)
    : null;

  const handleVerticalChange = (e) => {
    handleChange(e);
    setSelectedBranch(null);
    resetSearchFields(setFieldValue);
    setFieldValue("branch_name", "");
    setFieldValue("branch_id", "");
  };

  const handleTabChange = () => resetSearchFields(setFieldValue);

  return { searchConfig, activeCard, handleVerticalChange, handleTabChange };
};

export default useHomeForm;
